import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Customer-friendly document-processing error copy. Never surfaces raw
// provider/technical error text (e.g. Gemini/litellm exception strings).
export function getFriendlyUploadError(errorMessage) {
  const msg = (errorMessage || "").toLowerCase();
  if (
    msg.includes("no pages") ||
    msg.includes("zero pages") ||
    msg.includes("could not parse pdf") ||
    msg.includes("unreadable")
  ) {
    return "We couldn't read this PDF. It may be empty, damaged, or not a valid PDF. Please upload a valid PDF and try again.";
  }
  return "We couldn't process this document. Please try uploading it again.";
}
